import { render, staticRenderFns } from "./index.vue?vue&type=template&id=31153d84&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=31153d84&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31153d84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31153d84')) {
      api.createRecord('31153d84', component.options)
    } else {
      api.reload('31153d84', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=31153d84&scoped=true&", function () {
      api.rerender('31153d84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/HorizontalScroll/index.vue"
export default component.exports